import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { WhiteLabelService } from './core/white-label.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  appIcon: HTMLLinkElement = document.querySelector('#appIcon');
  appName: HTMLTitleElement = document.querySelector('#appName');

  constructor(whiteLabelService: WhiteLabelService, translateService: TranslateService) {
    whiteLabelService
      .getAppName$()
      .pipe(take(1))
      .subscribe({
        next: (appName) => {
          this.appName.text = appName;
        },
        error: () => (this.appName.text = translateService.instant('APP_NAME')),
      });
    whiteLabelService
      .getAppIconUrl$()
      .pipe(take(1))
      .subscribe({
        next: (appIconUrl) => {
          this.appIcon.href = appIconUrl;
        },
        error: () =>
          (this.appIcon.href = 'https://vstatic-prod.apigateway.co/customer-voice-client.9223372035073077600.prod/assets/images/favicon.ico'),
      });
  }
}
